import { Box } from "@chakra-ui/react";
import type { UtilizationReportOrderByColumn } from "@src/__generated__/graphql";
import type { UtilizationReportStore } from "@src/components/modules/reports/utilization/stores/utilization-report";
import { DataTable, LoadingOverlay } from "@src/components/ui-kit";
import { Pagination } from "@src/components/ui-kit/table/pagination";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import {
  type UtilizationTableRow,
  useUtilizationTableCols,
} from "../hooks/tableCols";

type Props = {
  store: UtilizationReportStore;
};
export const Table = observer(function Table({ store }: Props) {
  const cols = useUtilizationTableCols(store);
  const data = useMemo<UtilizationTableRow[]>(
    () =>
      store.tableData.map(({ user, report }, index) => ({
        id: index.toString(),
        user,
        report,
      })) ?? [],
    [store.tableData],
  );

  if (!cols) return null;

  return (
    <Box pos="relative">
      <LoadingOverlay
        isLoading={store.isReportLoading}
        position="absolute"
        size="lg"
      >
        <DataTable.Body<UtilizationTableRow, UtilizationReportOrderByColumn>
          tableKey={store.moduleKey}
          data={data}
          columns={cols}
          orderedBy={store.activeOrderBy}
          onOrderByChange={store.handleChangeOrderBy}
        />
      </LoadingOverlay>
      <Pagination store={store.pagination} />
    </Box>
  );
});
